import { render, staticRenderFns } from "./my-notifications.vue?vue&type=template&id=681c4e56&"
import script from "./my-notifications.vue?vue&type=script&lang=js&"
export * from "./my-notifications.vue?vue&type=script&lang=js&"
import style0 from "./my-notifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports